import { TargetingAccountPreferencesApiModel } from '../../../api/targeting/model/targeting-account-preferences.api.model';

export class DistributionQuotaInfo {
    baselineDistributions?: number;
    additionalDistributions?: number;
    usedDistributions?: number;
    totalDistributions?: number;
    totalDistributionsAvailable?: number;

    constructor(apiModel?: TargetingAccountPreferencesApiModel) {
        if (apiModel) {
            this.baselineDistributions = apiModel.baselineDistributions;
            this.additionalDistributions = apiModel.additionalDistributions;
            this.usedDistributions = apiModel.usedDistributions;
            this.totalDistributions = this.baselineDistributions + this.additionalDistributions;
            this.totalDistributionsAvailable = this.totalDistributions - this.usedDistributions;
        }
    }
}
